"use strict";

var _regeneratorRuntime = require("/root/ui-api/node_modules/@babel/runtime/regenerator");

require("core-js/modules/es.promise.js");

require("core-js/modules/es.object.keys.js");

require("core-js/modules/es.symbol.js");

require("core-js/modules/es.array.filter.js");

require("core-js/modules/es.object.get-own-property-descriptor.js");

require("core-js/modules/web.dom-collections.for-each.js");

require("core-js/modules/es.object.get-own-property-descriptors.js");

require("regenerator-runtime/runtime.js");

require("core-js/modules/es.string.starts-with.js");

require("core-js/modules/es.array.iterator.js");

require("core-js/modules/es.object.to-string.js");

require("core-js/modules/es.string.iterator.js");

require("core-js/modules/web.dom-collections.iterator.js");

require("core-js/modules/web.url.js");

require("core-js/modules/web.url-search-params.js");

require("core-js/modules/es.set.js");

require("core-js/modules/es.array.join.js");

var _debug = _interopRequireDefault(require("debug"));

var _config = _interopRequireDefault(require("../config"));

var _ecc = require("../auth/ecc");

var _fetchEx = _interopRequireDefault(require("../utils/fetchEx"));

var _keychain = require("./keychain");

var _misc = require("../utils/misc");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

var _apiHost;

var _uiHost;

var _clientId;

var _oauthNode, _oauthChainId;

var debug = (0, _debug.default)('golos:multiauth');
var AuthType = {
  OAUTH: 1,
  KEYCHAIN: 2
};

function apiHost() {
  if (_apiHost) return _apiHost;
  var KEY = 'oauth.host';

  var host = _config.default.get(KEY);

  if (!host) throw new Error(KEY + ' is not set in golos.config');
  if (!host.startsWith('http://') && !host.startsWith('https://')) host = 'https://' + host;

  try {
    _apiHost = new URL(host).origin;
  } catch (err) {
    throw new Error(KEY + ' cannot be parsed as URL: ' + host);
  }

  return _apiHost;
}

function uiHost() {
  if (_uiHost) return _uiHost;
  var KEY = 'oauth.ui_host';

  var host = _config.default.get(KEY);

  if (!host) {
    _uiHost = apiHost();
    return _uiHost;
  }

  if (!host.startsWith('http://') && !host.startsWith('https://')) host = 'https://' + host;

  try {
    _uiHost = new URL(host).origin;
  } catch (err) {
    throw new Error(KEY + ' cannot be parsed as URL: ' + host);
  }

  return _uiHost;
}

function clientId() {
  if (_clientId) return _clientId;
  var KEY = 'oauth.client';

  var client = _config.default.get(KEY);

  if (!client) throw new Error(KEY + ' is not set in golos.config');
  _clientId = client;
  return _clientId;
} // Keychain only signs transactions, but not sends them
// and we cannot use OAuth host if we are using KeyChain
// so we should use our node to send them


function setKeychainNodeIfCan() {
  var signedNode = _config.default.get('signed.websocket');

  if (signedNode) {
    _oauthNode = _config.default.get('websocket');

    _config.default.set('websocket', signedNode);
  }

  var signedCid = _config.default.get('signed.chain_id');

  if (signedCid) {
    _oauthChainId = _config.default.get('chain_id');

    _config.default.set('chain_id', signedCid);
  }
}

function switchBackToOAuth() {
  if (_oauthNode) {
    _config.default.set('websocket', _oauthNode);
  }

  if (_oauthChainId) {
    _config.default.set('chain_id', _oauthChainId);
  }
}

function _callApi(url, data) {
  var getHost = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : apiHost;
  var request = {
    method: data ? 'post' : 'get',
    credentials: 'include',
    headers: {
      Accept: 'application/json',
      'Content-type': data ? 'application/json' : undefined
    },
    body: data ? JSON.stringify(data) : undefined
  };
  return (0, _fetchEx.default)(new URL(url, getHost()), request);
}

function check() {
  return _check.apply(this, arguments);
}

function _check() {
  _check = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee() {
    var resKC, res;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return (0, _keychain.kcLoggedIn)();

          case 2:
            resKC = _context.sent;

            if (!resKC.authorized) {
              _context.next = 6;
              break;
            }

            setKeychainNodeIfCan();
            return _context.abrupt("return", _objectSpread(_objectSpread({}, resKC), {}, {
              authType: AuthType.KEYCHAIN
            }));

          case 6:
            _context.next = 8;
            return _callApi('/api/oauth/check/' + clientId());

          case 8:
            res = _context.sent;
            _context.next = 11;
            return res.json();

          case 11:
            res = _context.sent;
            return _context.abrupt("return", _objectSpread(_objectSpread({}, res), {}, {
              authType: AuthType.OAUTH
            }));

          case 13:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _check.apply(this, arguments);
}

function checkReliable() {
  return _checkReliable.apply(this, arguments);
}

function _checkReliable() {
  _checkReliable = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee2() {
    var onError,
        retry,
        res,
        _args2 = arguments;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            onError = _args2.length > 0 && _args2[0] !== undefined ? _args2[0] : undefined;
            retry = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : 1;
            res = null;
            _context2.prev = 3;
            _context2.next = 6;
            return check();

          case 6:
            res = _context2.sent;
            _context2.next = 23;
            break;

          case 9:
            _context2.prev = 9;
            _context2.t0 = _context2["catch"](3);

            if (!(onError && onError({
              retry: retry
            }))) {
              _context2.next = 13;
              break;
            }

            throw _context2.t0;

          case 13:
            if (onError) {
              _context2.next = 18;
              break;
            }

            if (!(retry > 10)) {
              _context2.next = 17;
              break;
            }

            console.error('multiauth.check stopped retrying');
            throw _context2.t0;

          case 17:
            console.error('multiauth.check error:', _context2.t0, 'retrying...');

          case 18:
            _context2.next = 20;
            return (0, _misc.delay)(3000);

          case 20:
            _context2.next = 22;
            return checkReliable(onError, ++retry);

          case 22:
            res = _context2.sent;

          case 23:
            return _context2.abrupt("return", res);

          case 24:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[3, 9]]);
  }));
  return _checkReliable.apply(this, arguments);
}

var waiters = new Set();
var waiterAutoInc = 0;

var stopped = function stopped(id, onFail) {
  if (!waiters.has(id)) {
    onFail();
    return true;
  }

  return false;
};

function waitingLoop(_x, _x2, _x3) {
  return _waitingLoop.apply(this, arguments);
}

function _waitingLoop() {
  _waitingLoop = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee3(id, onFinish, onFail) {
    var retries,
        onRetry,
        res,
        _args3 = arguments;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            retries = _args3.length > 3 && _args3[3] !== undefined ? _args3[3] : 180;
            onRetry = _args3.length > 4 && _args3[4] !== undefined ? _args3[4] : undefined;

            if (retries) {
              _context3.next = 6;
              break;
            }

            console.error('waiting for login is timeouted');
            onFail();
            return _context3.abrupt("return");

          case 6:
            if (!stopped(id, onFail)) {
              _context3.next = 8;
              break;
            }

            return _context3.abrupt("return");

          case 8:
            _context3.next = 10;
            return checkReliable();

          case 10:
            res = _context3.sent;

            if (!stopped(id, onFail)) {
              _context3.next = 13;
              break;
            }

            return _context3.abrupt("return");

          case 13:
            if (!res.authorized) {
              _context3.next = 17;
              break;
            }

            onFinish(res);
            _context3.next = 22;
            break;

          case 17:
            if (!(onRetry && onRetry({
              retriesLeft: retries
            }))) {
              _context3.next = 20;
              break;
            }

            onFail();
            return _context3.abrupt("return");

          case 20:
            debug('waiting for login...');
            setTimeout(function () {
              waitingLoop(id, onFinish, onFail, --retries, onRetry);
            }, 1000);

          case 22:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _waitingLoop.apply(this, arguments);
}

function waitForLogin(_x4, _x5) {
  return _waitForLogin.apply(this, arguments);
}

function _waitForLogin() {
  _waitForLogin = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee4(onFinish, onFail) {
    var retries,
        onRetry,
        _args4 = arguments;
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            retries = _args4.length > 2 && _args4[2] !== undefined ? _args4[2] : 180;
            onRetry = _args4.length > 3 && _args4[3] !== undefined ? _args4[3] : undefined;
            ++waiterAutoInc;
            waiters.clear();
            waiters.add(waiterAutoInc);
            _context4.next = 7;
            return waitingLoop(waiterAutoInc, onFinish, onFail, --retries, onRetry);

          case 7:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));
  return _waitForLogin.apply(this, arguments);
}

function login() {
  return _login.apply(this, arguments);
}

function _login() {
  _login = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee5() {
    var permissions,
        _ref,
        _ref$type,
        type,
        _ref$extraParams,
        extraParams,
        _args5 = arguments;

    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            permissions = _args5.length > 0 && _args5[0] !== undefined ? _args5[0] : [];
            _ref = _args5.length > 1 && _args5[1] !== undefined ? _args5[1] : {}, _ref$type = _ref.type, type = _ref$type === void 0 ? AuthType.OAUTH : _ref$type, _ref$extraParams = _ref.extraParams, extraParams = _ref$extraParams === void 0 ? '' : _ref$extraParams;

            if (!(typeof document === 'undefined')) {
              _context5.next = 4;
              break;
            }

            throw new Error('MultiAuth works only in browser environment (window should be defined)');

          case 4:
            if (!(type === AuthType.KEYCHAIN)) {
              _context5.next = 10;
              break;
            }

            _context5.next = 7;
            return (0, _keychain.assertKc)();

          case 7:
            _context5.next = 9;
            return (0, _keychain.kcLogin)();

          case 9:
            return _context5.abrupt("return", true);

          case 10:
            return _context5.abrupt("return", window.open(uiHost() + '/oauth/' + clientId() + '/' + permissions.join(',') + extraParams));

          case 11:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));
  return _login.apply(this, arguments);
}

function logout() {
  return _logout.apply(this, arguments);
}

function _logout() {
  _logout = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee6() {
    var res;
    return _regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            _context6.next = 2;
            return (0, _keychain.kcLogout)();

          case 2:
            if (_context6.sent) {
              _context6.next = 8;
              break;
            }

            _context6.next = 5;
            return _callApi('/api/oauth/logout/' + clientId());

          case 5:
            res = _context6.sent;
            _context6.next = 9;
            break;

          case 8:
            switchBackToOAuth();

          case 9:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6);
  }));
  return _logout.apply(this, arguments);
}

function _hashOps(operations) {
  var json = JSON.stringify(operations);

  var idHash = _ecc.hash.sha256(json, 'hex');

  return idHash;
}

function keychainInfo() {
  return _keychainInfo.apply(this, arguments);
}

function _keychainInfo() {
  _keychainInfo = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee7() {
    var info;
    return _regeneratorRuntime.wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            info = {
              installed: false,
              loadingBroken: false
            };
            _context7.prev = 1;
            _context7.next = 4;
            return (0, _keychain.waitForKc)();

          case 4:
            info.installed = _context7.sent;
            _context7.next = 11;
            break;

          case 7:
            _context7.prev = 7;
            _context7.t0 = _context7["catch"](1);
            console.error(_context7.t0);
            info.loadingBroken = true;

          case 11:
            return _context7.abrupt("return", info);

          case 12:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7, null, [[1, 7]]);
  }));
  return _keychainInfo.apply(this, arguments);
}

module.exports = {
  clientId: clientId,
  apiHost: apiHost,
  uiHost: uiHost,
  check: check,
  checkReliable: checkReliable,
  AuthType: AuthType,
  login: login,
  waitForLogin: waitForLogin,
  logout: logout,
  keychainInfo: keychainInfo,
  _callApi: _callApi,
  _hashOps: _hashOps
};